module.exports = __webpack_public_path__ + "img/public/SiteIcons/plusIcon.svg?aa2bdf79";